export const es: Record<string, string> = {
  "udra.catalogs.loadError": "No se pudieron cargar los catálogos.",
  "udra.catalogs.countError": "No se pudo consultar el total de artículos.",
  "udra.catalogs.requiredFields": "Completa los campos obligatorios.",
  "udra.catalogs.saveError": "No se pudo guardar el registro.",
  "udra.catalogs.deleted": "Registro eliminado correctamente.",
  "udra.catalogs.deleteError": "No se pudo eliminar el registro.",
  "udra.catalogs.categoryUpdated": "Categoría actualizada correctamente.",
  "udra.catalogs.categoryAdded": "Categoría agregada correctamente.",
  "udra.catalogs.unitUpdated": "Unidad de medida actualizada correctamente.",
  "udra.catalogs.unitAdded": "Unidad de medida agregada correctamente.",
  "udra.catalogs.maintenanceTitle": "Mantenimiento de tablas maestras",
  "udra.catalogs.description": "Categorías y unidades de medida, organizadas sin perder el contexto del catálogo.",
  "udra.catalogs.maintenance": "Mantenimiento",
  "udra.catalogs.categoriesTitle": "Subdivisión en categorías",
  "udra.catalogs.unitsTitle": "Lista de unidades de medida",
  "udra.catalogs.infoTitle": "Catálogos relacionados, a un paso del artículo",
  "udra.catalogs.infoDescription": "Acceso directo desde Mantenimiento. La observación se conserva como un dato opcional.",
  "udra.catalogs.editCategory": "Editar categoría",
  "udra.catalogs.addCategory": "Agregar categoría",
  "udra.catalogs.editUnit": "Editar unidad de medida",
  "udra.catalogs.addUnit": "Agregar unidad",
  "udra.catalogs.editorDescription": "Completa los datos del catálogo. Los campos con * son obligatorios.",
  "udra.catalogs.categoryPlaceholder": "Ej.: Materiales de oficina",
  "udra.catalogs.unitPlaceholder": "Ej.: Unidad",
  "udra.catalogs.type": "Tipo",
  "udra.catalogs.typePlaceholder": "Ej.: INT",
  "udra.catalogs.typeHelp": "Selecciona un tipo existente o escribe uno nuevo.",
  "udra.catalogs.optional": "(opcional)",
  "udra.catalogs.observationPlaceholder": "Información adicional",
  "udra.catalogs.saving": "Guardando…",
  "udra.catalogs.saveChanges": "Guardar cambios",
  "udra.catalogs.deleteCategory": "Eliminar categoría",
  "udra.catalogs.deleteUnit": "Eliminar unidad de medida",
  "udra.catalogs.deletePrompt": "¿Deseas eliminar {name} del catálogo?",
  "udra.catalogs.deleteRestriction": "El registro solo puede eliminarse si no está asociado a ningún artículo.",
  "udra.catalogs.deleting": "Eliminando…",
  "udra.catalogs.deleteRecord": "Eliminar registro",
  "udra.catalogs.maintenanceTabs": "Tablas de mantenimiento",
  "udra.catalogs.auxiliary": "Catálogos auxiliares",
  "udra.catalogs.categoryUnitCounts": "{categories} categorías / {units} unidades",
  "udra.catalogs.excelDownloaded": "Archivo Excel descargado.",
  "udra.catalogs.exportError": "No se pudo exportar el catálogo.",
  "udra.catalogs.updating": "Actualizando…",
  "udra.catalogs.recordCount": "{count} registros",
  "udra.catalogs.searchCategory": "Buscar categoría",
  "udra.catalogs.searchUnit": "Buscar unidad, tipo u observación",
  "udra.catalogs.scrollHint": "Desliza la tabla para ver todas las columnas y acciones.",
  "udra.catalogs.scrollLabel": "{title}, desplazamiento horizontal y vertical",
  "udra.catalogs.number": "N°",
  "udra.catalogs.loading": "Cargando catálogo…",
  "udra.catalogs.unavailable": "Catálogo no disponible",
  "udra.catalogs.noRecords": "No se encontraron registros",
  "udra.catalogs.searchEmptyHint": "Prueba con otra descripción o limpia la búsqueda.",
  "udra.catalogs.emptyHint": "Agrega un registro para empezar a organizar tus artículos.",
  "udra.catalogs.clearSearch": "Limpiar búsqueda",
  "udra.catalogs.editNamed": "Editar {name}",
  "udra.catalogs.deleteNamed": "Eliminar {name}",
  "udra.catalogs.categoryRange": "{first}–{last} de {total} categorías",
  "udra.catalogs.unitRange": "{first}–{last} de {total} unidades de medida",
  "udra.catalogs.totalRecords": "{count} registros en el catálogo",
  "udra.catalogs.pageOf": "Página {page} de {total}",
  "udra.catalogs.categoryPages": "Páginas de categorías",
  "udra.catalogs.unitPages": "Páginas de unidades",
  "udra.catalogs.previousPage": "Página anterior",
  "udra.catalogs.nextPage": "Página siguiente",
  "udra.catalogs.pageNumber": "Página {page}",
  "udra.articles.loadError": "No se pudieron cargar los artículos.",
  "udra.articles.exportError": "No se pudo exportar el archivo.",
  "udra.articles.fullscreenError": "El navegador no permite ampliar la tabla en este momento.",
  "udra.articles.requiredFields": "Completa la descripción, la categoría y la unidad de medida.",
  "udra.articles.updated": "Artículo actualizado correctamente.",
  "udra.articles.added": "Artículo agregado correctamente.",
  "udra.articles.saveError": "No se pudo guardar el artículo.",
  "udra.articles.deleted": "Artículo eliminado correctamente.",
  "udra.articles.deleteError": "No se pudo eliminar el artículo.",
  "udra.articles.title": "Artículos",
  "udra.articles.description": "Administra los artículos y sus catálogos desde un mismo espacio.",
  "udra.articles.add": "Agregar artículo",
  "udra.articles.loadedAt": "Fecha de carga: {date}",
  "udra.articles.searchLabel": "Buscar artículo por descripción u observación",
  "udra.articles.searchPlaceholder": "Buscar por descripción u observación",
  "udra.articles.category": "Categoría",
  "udra.articles.filterCategory": "Filtrar por categoría",
  "udra.articles.allCategories": "Todas las categorías",
  "udra.articles.unit": "Unidad de medida",
  "udra.articles.filterUnit": "Filtrar por unidad de medida",
  "udra.articles.allUnits": "Todas las unidades",
  "udra.articles.clearFilters": "Limpiar filtros",
  "udra.articles.listLabel": "Listado de artículos",
  "udra.articles.updating": "Actualizando artículos…",
  "udra.articles.names": "Nombres de los artículos",
  "udra.articles.exitFullscreen": "Salir de pantalla completa",
  "udra.articles.enterFullscreen": "Ampliar tabla a pantalla completa",
  "udra.articles.expandTable": "Ampliar tabla",
  "udra.articles.updateError": "No se pudo actualizar la lista.",
  "udra.articles.lastResults": "Se muestran los últimos resultados disponibles.",
  "udra.articles.scrollLabel": "Tabla de artículos, desplazamiento horizontal y vertical",
  "udra.articles.tableLabel": "Artículos del catálogo ENAPRES",
  "udra.articles.articleDescription": "Descripción del artículo",
  "udra.articles.loading": "Cargando artículos…",
  "udra.articles.catalogError": "No se pudo cargar el catálogo",
  "udra.articles.noArticles": "No se encontraron artículos",
  "udra.articles.searchEmptyHint": "Prueba con otra búsqueda o modifica los filtros.",
  "udra.articles.emptyHint": "Agrega el primer artículo al catálogo de ENAPRES.",
  "udra.articles.range": "{first}–{last} de {total} artículos",
  "udra.articles.filteredResults": "Resultado filtrado",
  "udra.articles.pages": "Páginas de artículos",
  "udra.articles.edit": "Editar artículo",
  "udra.articles.editorDescription": "Completa los datos del artículo. Los campos con * son obligatorios.",
  "udra.articles.namePlaceholder": "Ej.: Cuaderno cuadriculado A4",
  "udra.articles.selectCategory": "Selecciona una categoría",
  "udra.articles.selectUnit": "Selecciona una unidad",
  "udra.articles.observationPlaceholder": "Información adicional sobre el artículo",
  "udra.articles.catalogHint": "Las categorías y unidades se administran en Catálogos auxiliares.",
  "udra.articles.delete": "Eliminar artículo",
  "udra.articles.deleteRestriction": "Solo se pueden eliminar artículos que no tienen movimientos ni asignaciones registrados."
}

export const en: Record<string, string> = {
  "udra.catalogs.loadError": "The catalogs could not be loaded.",
  "udra.catalogs.countError": "The total item count could not be retrieved.",
  "udra.catalogs.requiredFields": "Complete the required fields.",
  "udra.catalogs.saveError": "The record could not be saved.",
  "udra.catalogs.deleted": "Record deleted successfully.",
  "udra.catalogs.deleteError": "The record could not be deleted.",
  "udra.catalogs.categoryUpdated": "Category updated successfully.",
  "udra.catalogs.categoryAdded": "Category added successfully.",
  "udra.catalogs.unitUpdated": "Unit of measure updated successfully.",
  "udra.catalogs.unitAdded": "Unit of measure added successfully.",
  "udra.catalogs.maintenanceTitle": "Master data maintenance",
  "udra.catalogs.description": "Categories and units of measure, organized within the catalog.",
  "udra.catalogs.maintenance": "Maintenance",
  "udra.catalogs.categoriesTitle": "Category breakdown",
  "udra.catalogs.unitsTitle": "Units of measure",
  "udra.catalogs.infoTitle": "Related catalogs, one step away from each item",
  "udra.catalogs.infoDescription": "Access directly from Maintenance. Notes remain optional.",
  "udra.catalogs.editCategory": "Edit category",
  "udra.catalogs.addCategory": "Add category",
  "udra.catalogs.editUnit": "Edit unit of measure",
  "udra.catalogs.addUnit": "Add unit",
  "udra.catalogs.editorDescription": "Complete the catalog details. Fields marked * are required.",
  "udra.catalogs.categoryPlaceholder": "e.g., Office supplies",
  "udra.catalogs.unitPlaceholder": "e.g., Unit",
  "udra.catalogs.type": "Type",
  "udra.catalogs.typePlaceholder": "e.g., INT",
  "udra.catalogs.typeHelp": "Select an existing type or enter a new one.",
  "udra.catalogs.optional": "(optional)",
  "udra.catalogs.observationPlaceholder": "Additional information",
  "udra.catalogs.saving": "Saving…",
  "udra.catalogs.saveChanges": "Save changes",
  "udra.catalogs.deleteCategory": "Delete category",
  "udra.catalogs.deleteUnit": "Delete unit of measure",
  "udra.catalogs.deletePrompt": "Do you want to delete {name} from the catalog?",
  "udra.catalogs.deleteRestriction": "A record can only be deleted if it is not associated with any item.",
  "udra.catalogs.deleting": "Deleting…",
  "udra.catalogs.deleteRecord": "Delete record",
  "udra.catalogs.maintenanceTabs": "Maintenance tables",
  "udra.catalogs.auxiliary": "Supporting catalogs",
  "udra.catalogs.categoryUnitCounts": "{categories} categories / {units} units",
  "udra.catalogs.excelDownloaded": "Excel file downloaded.",
  "udra.catalogs.exportError": "The catalog could not be exported.",
  "udra.catalogs.updating": "Updating…",
  "udra.catalogs.recordCount": "{count} records",
  "udra.catalogs.searchCategory": "Search categories",
  "udra.catalogs.searchUnit": "Search units, types or notes",
  "udra.catalogs.scrollHint": "Scroll the table to view all columns and actions.",
  "udra.catalogs.scrollLabel": "{title}, horizontal and vertical scrolling",
  "udra.catalogs.number": "No.",
  "udra.catalogs.loading": "Loading catalog…",
  "udra.catalogs.unavailable": "Catalog unavailable",
  "udra.catalogs.noRecords": "No records found",
  "udra.catalogs.searchEmptyHint": "Try another description or clear the search.",
  "udra.catalogs.emptyHint": "Add a record to start organizing your items.",
  "udra.catalogs.clearSearch": "Clear search",
  "udra.catalogs.editNamed": "Edit {name}",
  "udra.catalogs.deleteNamed": "Delete {name}",
  "udra.catalogs.categoryRange": "{first}–{last} of {total} categories",
  "udra.catalogs.unitRange": "{first}–{last} of {total} units of measure",
  "udra.catalogs.totalRecords": "{count} records in the catalog",
  "udra.catalogs.pageOf": "Page {page} of {total}",
  "udra.catalogs.categoryPages": "Category pages",
  "udra.catalogs.unitPages": "Unit pages",
  "udra.catalogs.previousPage": "Previous page",
  "udra.catalogs.nextPage": "Next page",
  "udra.catalogs.pageNumber": "Page {page}",
  "udra.articles.loadError": "The items could not be loaded.",
  "udra.articles.exportError": "The file could not be exported.",
  "udra.articles.fullscreenError": "The browser cannot display the table in full screen at this time.",
  "udra.articles.requiredFields": "Complete the description, category and unit of measure.",
  "udra.articles.updated": "Item updated successfully.",
  "udra.articles.added": "Item added successfully.",
  "udra.articles.saveError": "The item could not be saved.",
  "udra.articles.deleted": "Item deleted successfully.",
  "udra.articles.deleteError": "The item could not be deleted.",
  "udra.articles.title": "Items",
  "udra.articles.description": "Manage items and their catalogs in one place.",
  "udra.articles.add": "Add item",
  "udra.articles.loadedAt": "Loaded: {date}",
  "udra.articles.searchLabel": "Search items by description or notes",
  "udra.articles.searchPlaceholder": "Search by description or notes",
  "udra.articles.category": "Category",
  "udra.articles.filterCategory": "Filter by category",
  "udra.articles.allCategories": "All categories",
  "udra.articles.unit": "Unit of measure",
  "udra.articles.filterUnit": "Filter by unit of measure",
  "udra.articles.allUnits": "All units",
  "udra.articles.clearFilters": "Clear filters",
  "udra.articles.listLabel": "Item list",
  "udra.articles.updating": "Updating items…",
  "udra.articles.names": "Item names",
  "udra.articles.exitFullscreen": "Exit full screen",
  "udra.articles.enterFullscreen": "Expand table to full screen",
  "udra.articles.expandTable": "Expand table",
  "udra.articles.updateError": "The list could not be updated.",
  "udra.articles.lastResults": "Showing the latest available results.",
  "udra.articles.scrollLabel": "Items table, horizontal and vertical scrolling",
  "udra.articles.tableLabel": "ENAPRES catalog items",
  "udra.articles.articleDescription": "Item description",
  "udra.articles.loading": "Loading items…",
  "udra.articles.catalogError": "The catalog could not be loaded",
  "udra.articles.noArticles": "No items found",
  "udra.articles.searchEmptyHint": "Try another search or change the filters.",
  "udra.articles.emptyHint": "Add the first item to the ENAPRES catalog.",
  "udra.articles.range": "{first}–{last} of {total} items",
  "udra.articles.filteredResults": "Filtered results",
  "udra.articles.pages": "Item pages",
  "udra.articles.edit": "Edit item",
  "udra.articles.editorDescription": "Complete the item details. Fields marked * are required.",
  "udra.articles.namePlaceholder": "e.g., A4 graph paper notebook",
  "udra.articles.selectCategory": "Select a category",
  "udra.articles.selectUnit": "Select a unit",
  "udra.articles.observationPlaceholder": "Additional information about the item",
  "udra.articles.catalogHint": "Categories and units are managed in Supporting catalogs.",
  "udra.articles.delete": "Delete item",
  "udra.articles.deleteRestriction": "Only items with no recorded movements or assignments can be deleted."
}
